import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (common in React with dynamic content)
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop') || 
      (typeof args[0] === 'string' && args[0].includes('ResizeObserver'))) {
    return;
  }
  resizeObserverErr(...args);
};

// Also suppress via window error handler
window.addEventListener('error', (e) => {
  if (e.message?.includes?.('ResizeObserver loop')) {
    e.stopPropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
